<template>
  <section class="post-preview-page">
    <div>
      <h3>Post Body (English)</h3>
      <article-html :content="postPreview.en" />
    </div>
    <div>
      <h3>Post Body (Traditional Chinese)</h3>
      <article-html :content="postPreview.hk" />
    </div>
  </section>
</template>
<script>
import { mapState } from 'vuex'
import ArticleHtml from './components/article-html'

export default {
  name: 'PostPreviewPage',
  components: {
    ArticleHtml
  },
  computed: {
    ...mapState('news', ['postPreview'])
  }
}
</script>
<style lang="scss" scoped>
.post-preview-page {
  position: relative;
  display: flex;
  justify-content: space-between;
  padding: 30px;
  max-height: 100vh;
  overflow-y: auto;
  & > div {
    // flex: 1;
    width: calc(50% - 10px);
    max-width: 800px;
    /deep/ .ed-article {
      padding-bottom: 100px;
    }
  }
}
</style>